export default __webpack_public_path__ + "static/media/dodecahedron.21ef28ad.glb";